import { Box, Flex, Heading } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

/**
 * Card shell shared by every section of the dashboard home (setup progress,
 * account summary, and the sections still to come), so they line up and
 * theme the same way.
 *
 * @param {object} props
 * @param {import('react').ReactNode} props.title
 * @param {import('react').ReactNode} [props.icon] - shown before the title
 * @param {import('react').ReactNode} [props.action] - right side of the header
 */
const DashboardPanel = ({ title, icon, action, children, ...boxProps }) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Box
            as="section"
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            bg={darkMode ? 'dark.tcap' : 'white'}
            borderColor={darkMode ? 'gray.700' : 'gray.200'}
            p={4}
            {...boxProps}>
            <Flex align="center" justify="space-between" gap={4} wrap="wrap">
                <Flex align="center" gap={2}>
                    {icon}
                    <Heading
                        as="h2"
                        fontSize="md"
                        fontWeight="bold"
                        color={darkMode ? 'white' : 'gray.900'}>
                        {title}
                    </Heading>
                </Flex>
                {action}
            </Flex>
            {children}
        </Box>
    );
};

export default DashboardPanel;
